{
  "dropzoneLabel": "„DropZone“",
  "selectPlaceholder": "Pasirinkite elementą",
  "tableResizer": "Dydžio keitiklis",
  "colorSwatchPicker": "Color swatches"
}
